import styled from "styled-components";

import {
	FONT_WT_MEDIUM,
	MOBILE_L_BP,
	COLOR_TEXT_PRIMARY_B2C,
} from "@website-builder/utilities-index";
export const AlumniImage = styled.div`
	picture {
		img {
			margin: auto;
			height: 242px;
			border-radius: 50%;
		}
	}

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		picture {
			img {
				margin: auto;
				height: 163px;
				border-radius: 50%;
			}
		}
	}
`;
export const Subtitle = styled.span`
	p {
		padding-top: 20px;
		font-style: italic;
		font-weight: 300;
		font-size: 16px;
		line-height: 20px;
		margin-left: auto;
		margin-right: auto;
		text-align: center;

		color: ${COLOR_TEXT_PRIMARY_B2C};
	}
`;
export const Title = styled.span`
	p {
		margin-left: auto;
		margin-right: auto;
		margin-top: 12px;
		font-weight: ${FONT_WT_MEDIUM};
		font-size: 20px;
		line-height: 20px;
		margin-bottom: 0;
		text-align: center;
		color: ${COLOR_TEXT_PRIMARY_B2C};
	}
`;
export const Logo = styled.div`
	picture {
		img {
			margin: 23px auto 23px auto;
			height: 60px;
		}
	}
`;
export const Container = styled.div`
	height: 514px;
	text-align: center;

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		height: 430px;
	}
`;
